
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { colors } from '~/helpers/colors'

export default {
  props: {
    filterValue: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    selectedCheckbox: '',
    isFocused: false,
  }),
  computed: {
    ...mapGetters({
      vxSearchFilters: 'search/getSearchFilters',
    }),
    searchFilters: {
      get() {
        return this.vxSearchFilters
      },
      set(value) {
        this.vxSetSearchFilters(value)
        this.vxQuerySearchspring()
      },
    },
    isSelected() {
      return this.vxSearchFilters.includes(this.filterValue)
    },
    filterLabel() {
      // PRICES
      if (this.filterValue.includes('ss_final_price')) {
        const [priceLow, priceHigh] = this.filterValue.split('&')
        const lowValue = priceLow.split('=')[1]
        const highValue = priceHigh.split('=')[1]
        return `$${lowValue === '*' ? 0 : lowValue} - $${highValue}`

        // ALL OTHER FILTERS
      } else {
        const [filterKey, filterValue] = this.filterValue.split('=')

        if (filterKey === 'filter.ss_normalize_color') {
          return this.colorSwatch(filterValue)
        } else {
          return filterValue
        }
      }
    },
  },
  methods: {
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    ...mapMutations({
      vxSetSearchFilters: 'search/setSearchFilters',
    }),
    colorSwatch(colorCode) {
      return colors[colorCode].EN
    },
  },
}
